import * as messages from '@cucumber/messages'
import { Expression } from '@cucumber/cucumber-expressions'
import { ITestCaseHookParameter } from '../support_code_library_builder/types'
import { GherkinStepKeyword } from './gherkin_step_keyword'

export interface IGetInvocationDataRequest {
  hookParameter: ITestCaseHookParameter
  step: messages.PickleStep
  world: any
}

export interface IGetInvocationDataResponse {
  getInvalidCodeLengthMessage: () => string
  parameters: any[]
  validCodeLengths: number[]
}

export interface IDefinitionOptions {
  timeout?: number
  wrapperOptions?: any
}

export interface IHookDefinitionOptions extends IDefinitionOptions {
  name?: string
  tags?: string
}

export interface IDefinitionParameters<T extends IDefinitionOptions> {
  code: Function
  id: string
  line: number
  options: T
  order: number
  unwrappedCode?: Function
  uri: string
}

export interface IStepDefinitionParameters
  extends IDefinitionParameters<IDefinitionOptions> {
  keyword: GherkinStepKeyword
  pattern: string | RegExp
  expression: Expression
}

export interface IDefinition {
  readonly code: Function
  readonly id: string
  readonly line: number
  readonly options: IDefinitionOptions
  readonly order: number
  readonly unwrappedCode: Function
  readonly uri: string

  getInvocationParameters: (
    options: IGetInvocationDataRequest
  ) => Promise<IGetInvocationDataResponse>
}

export default abstract class Definition {
  public readonly code: Function
  public readonly id: string
  public readonly line: number
  public readonly options: IDefinitionOptions
  public readonly order: number
  public readonly unwrappedCode: Function
  public readonly uri: string

  constructor({
    code,
    id,
    line,
    options,
    order,
    unwrappedCode,
    uri,
  }: IDefinitionParameters<IDefinitionOptions>) {
    this.code = code
    this.id = id
    this.line = line
    this.options = options
    this.order = order
    this.unwrappedCode = unwrappedCode
    this.uri = uri
  }

  buildInvalidCodeLengthMessage(
    syncOrPromiseLength: number | string,
    callbackLength: number | string
  ): string {
    return (
      `function has ${this.code.length.toString()} arguments` +
      `, should have ${syncOrPromiseLength.toString()} (if synchronous or returning a promise)` +
      ` or ${callbackLength.toString()} (if accepting a callback)`
    )
  }

  baseGetInvalidCodeLengthMessage(parameters: any[]): string {
    return this.buildInvalidCodeLengthMessage(
      parameters.length,
      parameters.length + 1
    )
  }
}
